import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../../models/api-response';

@Injectable({ providedIn: 'root' })
export class ProfileService {
  constructor(private http: HttpClient) {}

  changePassword(request: {
    currentPassword: string;
    newPassword: string;
  }) {
    return this.http.post<ApiResponse<any>>(
      `${environment.apiBaseUrl}/admin/profile/change-password`,
      request
    );
  }
}